import React from "react";

// import { FilterCheckBox, FilterTabs, FilterRadio, FilterDate } from "../Filters";
function tooltip(tooltip) {
  if (tooltip) return <i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip={tooltip}></i>
  else return null
}

export const FormInputFile = props => <>
  <label class="custom-file">{tooltip(props.tooltip)} <strong>{props.label} {props.required ? <i class="color-categorical-5">*</i> : null}</strong>
    <span>Upload</span>
    {props.required ? <input type="file" id={props.id} name={props.name} onChange={props.uploadFile} accept={props.accept} required /> : <input type="file" id={props.id} name={props.name} onChange={props.uploadFile} accept={props.accept} />}
  </label>
</>
